import React from 'react';

import { BaseIconProps } from '@atoms';

export const CheckmarkRoundedLess = ({ fill }: BaseIconProps) => (
  <g transform="matrix(18.938048,0,0,18.938048,-10813.625,-2083.1853)">
    <rect
      width="57"
      height="57"
      rx="8"
      transform="translate(571,110)"
      fill={fill}
      x="0"
      y="0"
    />
    <path
      d="M 14.821,3.492 11.232,0 0,10.414 20.183,30.786 23.774,27.294 7.207,10.414 Z"
      transform="rotate(-92.98,364.27054,-201.83793)"
      fill="#ffffff"
    />
  </g>
);
